// extracted by mini-css-extract-plugin
export default {"body":"Login_body__tLJ+p","loginButtons":"Login_loginButtons__4z6ea"};